import OverviewPage from 'pages/app/LIA/Overview';
import ReportsPage from 'pages/app/LIA/Reports';
import NotificationsPage from 'pages/app/LIA/Notifications';
import AssessmentSchedulesPage from 'pages/app/LIA/AssessmentSchedules';
import MasterGroupPage from 'pages/app/LIA/Master Group';
import AddMasterGroupPage from 'pages/app/LIA/Master Group/Add';
import EditMasterQuestion from 'pages/app/LIA/Master Question/Edit';
import MasterQuestionPage from 'pages/app/LIA/Master Question';
import AddMasterQuestionPage from 'pages/app/LIA/Master Question/Add';
import AddAssessmentSchedulePage from 'pages/app/LIA/AssessmentSchedules/Add';
import EditMasterGroupPage from 'pages/app/LIA/Master Group/Edit';
import AssessmentDetailPage from 'pages/app/LIA/AssessmentSchedules/Detail';
import EditAssessmentSchedulePage from 'pages/app/LIA/AssessmentSchedules/Edit';
import RangeTemplatePage from 'pages/app/LIA/RangeTemplate';
import AddRangeTemplatePage from 'pages/app/LIA/RangeTemplate/Add';
import EditRangeTemplatePage from 'pages/app/LIA/RangeTemplate/Edit';
import ViewRangeTemplatePage from 'pages/app/LIA/RangeTemplate/View';

export const pathnames = {
  overview: '/app/lia/overview',
  reports: '/app/lia/reports',
  notifications: '/app/lia/notifications',
  assessmentSchedules: '/app/lia/assessment-schedules',
  assessmentSchedulesDetail: '/app/lia/assessment-schedules/detail/:id',
  addAssessmentSchedules: '/app/lia/assessment-schedules/add',
  editAssessmentSchedules: '/app/lia/assessment-schedules/edit/:id',
  detailAssessmentSchedules: '/app/lia/assessment-schedules/detail',
  questions: '/app/lia/questions/master-questions',
  addQuestions: '/app/lia/questions/master-questions/add',
  editQuestions: '/app/lia/questions/master-questions/edit',
  groupQuestions: '/app/lia/questions/group-questions',
  addGroupQuestions: '/app/lia/questions/group-questions/add',
  editGroupQuestions: '/app/lia/questions/group-questions/edit',
  rangeTemplates: '/app/lia/questions/range-templates',
  addRangeTemplate: '/app/lia/questions/range-templates/add',
  editRangeTemplate: '/app/lia/questions/range-templates/edit',
  viewRangeTemplate: '/app/lia/questions/range-templates/view',
  smeAssessmentDetail: '/public/sme/assessment-schedules/detail'
};

const LIARoutes = [
  {
    path: pathnames.overview,
    element: <OverviewPage />
  },
  {
    path: pathnames.reports,
    element: <ReportsPage />
  },
  {
    path: pathnames.notifications,
    element: <NotificationsPage />
  },
  {
    path: pathnames.assessmentSchedules,
    element: <AssessmentSchedulesPage />
  },
  {
    path: pathnames.assessmentSchedulesDetail,
    element: <AssessmentDetailPage />
  },
  {
    path: pathnames.addAssessmentSchedules,
    element: <AddAssessmentSchedulePage />
  },
  {
    path: pathnames.editAssessmentSchedules,
    element: <EditAssessmentSchedulePage />
  },
  {
    path: pathnames.questions,
    element: <MasterQuestionPage />
  },
  {
    path: pathnames.addQuestions,
    element: <AddMasterQuestionPage />
  },
  {
    path: pathnames.editQuestions,
    element: <EditMasterQuestion />
  },
  {
    path: pathnames.groupQuestions,
    element: <MasterGroupPage />
  },
  {
    path: pathnames.addGroupQuestions,
    element: <AddMasterGroupPage />
  },
  {
    path: pathnames.editGroupQuestions,
    element: <EditMasterGroupPage />
  },
  {
    path: pathnames.rangeTemplates,
    element: <RangeTemplatePage />
  },
  {
    path: pathnames.addRangeTemplate,
    element: <AddRangeTemplatePage />
  },
  {
    path: pathnames.editRangeTemplate,
    element: <EditRangeTemplatePage />
  },
  {
    path: pathnames.viewRangeTemplate,
    element: <ViewRangeTemplatePage />
  }
];

export default LIARoutes;
